"use strict";module.exports=function(r){if(null==r)throw TypeError("Can't call method on  "+r);return r};